// extracted by mini-css-extract-plugin
module.exports = {"links":"az_q4c"};